import { FC } from 'react';

import bootstrapPage, { BootstrapPageProps } from '../../HOCs/bootstrapPage';
import MetaHead from '../../components/MetaHead';
import TermsUseSection from '../../components/TermsUseSection';
import StudioLayout from '../../components/layouts/StudioLayout';

const TermsUsePage: FC<BootstrapPageProps> = () => (
  <>
    <MetaHead title="Terms of Use" />
    <StudioLayout navigationVariant="pink">
      <TermsUseSection
        supportEmail="support@animatron.com"
        contactEmail="legal@animatron.com"
        webSite="animatron.com"
        product="Animatron Studio"
      />
    </StudioLayout>
  </>
);

export default bootstrapPage(TermsUsePage);
